import React from 'react'
import styled from 'styled-components'
import { Box } from 'reflexbox'
import TextField from '@mui/material/TextField';

const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  font-family: 'Roboto';
`

const CustomTextField = styled(TextField)({
  '& .MuiInput-root': {
    fontFamily: 'Roboto',
    padding: '0% 14px',
  },
  "& .MuiInputLabel-root": {
    marginLeft: '14px',
    fontFamily: 'Roboto',
    fontWeight: '500',
    color: 'black',
  },
  "&:hover .MuiInputLabel-root": {
    fontFamily: 'Roboto',
    fontWeight: '500',
    color: 'black',
  },
  '& label.Mui-focused': {
    fontFamily: 'Roboto',
    fontWeight: '500',
    color: 'black',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'rgba(0, 0, 0, 0.42)',
  },
  '& .MuiInput-placeholder': {
    fontFamily: 'Roboto',
  },
  '& .MuiFormHelperText-root': {
    fontFamily: 'Roboto',
    padding: '0% 14px',
  },
});

const TextFieldForm = props => {
  return (
    <Wrapper>
      <CustomTextField
        fullWidth
        id={props.id}
        name={props.name}
        label={props.label}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onKeyDown={props.onKeyDown}
        error={props.error}
        helperText={props.helperText}
        inputProps={props.inputProps}
        required={props.required}        
        InputLabelProps={{ shrink: true }}
        variant="standard"
      />
    </Wrapper>
  )
}

export default TextFieldForm